import i18next from 'i18next';

import type { TranslationVariables } from '../models/translations';

export const translateText = (
  key: string,
  variables?: TranslationVariables
): string => {
  return i18next.t(key, variables);
};

export const translateTextWithPrefix =
  (modulePrefix: string) =>
  (key: string, variables?: TranslationVariables): string => {
    return i18next.t(`${modulePrefix}.${key}`, variables);
  };
